import * as Yup from "yup";

export const CertificateSchema = Yup.object().shape({
    // heading: Yup.string().required("Enter Heading"),
    // certificate_border: Yup.string().notRequired("Select Border"),
    // border_color: Yup.string().notRequired("Choose Border Color"),
    // background_img: Yup.string().notRequired("Choose Background"),
    // logo: Yup.string().required("Choose Logo"),
    // logo_allignment: Yup.string().required("Select Allignment"),
    hod_name: Yup.string().required("Enter HOD Name"),
    signature: Yup.string().required("Choose Signature"),
});